export default __webpack_public_path__ + "static/media/template configuration.aae5e7bc.png";